/* unplugin-vue-components disabled */import { render } from "./DownloadSVG.vue?vue&type=template&id=2540195d"
import script from "./DownloadSVG.vue?vue&type=script&lang=js"
export * from "./DownloadSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__